__turbopack_context__.v({
  "Search": "nDgjAq_Search",
  "acervoImagemEFlags": "nDgjAq_acervoImagemEFlags",
  "acervoList": "nDgjAq_acervoList",
  "acervoListagemInformacoes": "nDgjAq_acervoListagemInformacoes",
  "autorLivro": "nDgjAq_autorLivro",
  "btnSearch": "nDgjAq_btnSearch",
  "carouselBooks": "nDgjAq_carouselBooks",
  "carregarMais": "nDgjAq_carregarMais",
  "containerAcervo": "nDgjAq_containerAcervo",
  "containerImgFlags": "nDgjAq_containerImgFlags",
  "contentAcervo": "nDgjAq_contentAcervo",
  "epub": "nDgjAq_epub",
  "filter": "nDgjAq_filter",
  "filterAcervo": "nDgjAq_filterAcervo",
  "headerAcervo": "nDgjAq_headerAcervo",
  "imgAcervo": "nDgjAq_imgAcervo",
  "inputSearch": "nDgjAq_inputSearch",
  "itemAcervo": "nDgjAq_itemAcervo",
  "itemAcervoBook": "nDgjAq_itemAcervoBook",
  "itemFlag": "nDgjAq_itemFlag",
  "nossoAcervo": "nDgjAq_nossoAcervo",
  "novo": "nDgjAq_novo",
  "pdf": "nDgjAq_pdf",
  "rowAcervo": "nDgjAq_rowAcervo",
  "swiper": "nDgjAq_swiper",
  "title": "nDgjAq_title",
  "tituloLivro": "nDgjAq_tituloLivro",
  "uiContainer": "nDgjAq_uiContainer",
});
